import { useGoogleAnalytics } from './GAVolto';

const GA = ({ performanceCookies }) => {
  useGoogleAnalytics(performanceCookies);
  return null;
};

export default GA;
